export default __webpack_public_path__ + "static/media/logo.facae9b3.png";